import type { ContentHref } from '@generalTypes/apiTypes';
import { refetchDocument } from '@newStore/documentApi/documentApiState';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BACK_TO_DOCUMENTS_LIST } from '@store/constants/actionTypes';
import { setSelectedDocument } from '../documentUI/documentUIState';

export type DocumentSpecificState = {
  isGlobalDocumentIncludedInProTheme: boolean | null;
};

export type IsGlobalDocumentIncludedInProThemePayloadAction = PayloadAction<{ href: ContentHref }>;

const getInitialState = (): DocumentSpecificState => ({
  isGlobalDocumentIncludedInProTheme: null,
});

const documentSpecificSlice = createSlice({
  name: 'documentSpecific',
  initialState: getInitialState,
  reducers: {
    getIsGlobalDocumentIncludedInProTheme(
      _state,
      _action: IsGlobalDocumentIncludedInProThemePayloadAction,
    ) {},
    setIsGlobalDocumentIncludedInProTheme(state, action: PayloadAction<boolean>) {
      state.isGlobalDocumentIncludedInProTheme = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(refetchDocument, () => {
      const initialState = getInitialState();
      return initialState;
    });
    builder.addCase(setSelectedDocument, () => {
      const initialState = getInitialState();
      return initialState;
    });
    builder.addCase(BACK_TO_DOCUMENTS_LIST, () => {
      const initialState = getInitialState();
      return initialState;
    });
  },
});

export const { getIsGlobalDocumentIncludedInProTheme, setIsGlobalDocumentIncludedInProTheme } =
  documentSpecificSlice.actions;
export default documentSpecificSlice.reducer;
